if (!customElements.get('trade-menu')) {
  customElements.define('trade-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.panel = this.querySelector('.trade-menu__panel');
      this.mobile = this.closest('.trade-menu-item--mobile');
      this.details.addEventListener('toggle', () => {
        if (!this.details.open) return;
        document.querySelectorAll('trade-menu details[open]').forEach(details => {
          if (details !== this.details) details.open = false;
        });
        this.positionPanel();
        if (this.mobile) this.querySelector('.trade-menu__back').focus();
      }, options);
      this.querySelector('.trade-menu__back')?.addEventListener('click', () => {
        this.details.open = false;
        this.trigger.focus();
      }, options);
      if (this.mobile) {
        this.menuObserver = new MutationObserver(() => {
          if (!document.body.classList.contains('open-mobilemenu')) this.details.open = false;
        });
        this.menuObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }
      this.addEventListener('pointerenter', event => {
        if (!this.mobile && event.pointerType === 'mouse') this.details.open = true;
      }, options);
      this.addEventListener('pointerleave', event => {
        if (!this.mobile && event.pointerType === 'mouse' && !this.contains(document.activeElement)) this.details.open = false;
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          this.details.open = false;
          this.trigger.focus();
          event.stopPropagation();
        }
      }, options);
      this.addEventListener('focusout', event => {
        // Safari can blur the Back button without focusing the tapped link.
        // Keep the panel visible until the native click can navigate.
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.details.open = false;
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.details.open = false;
      }, options);
      window.addEventListener('resize', () => this.positionPanel(), options);
      document.addEventListener('shopify:block:select', event => {
        if (event.target === this.closest('.trade-menu-item')) this.details.open = true;
      }, options);
      document.addEventListener('shopify:block:deselect', () => { this.details.open = false; }, options);
    }
    positionPanel() {
      if (this.mobile || !this.details.open) return;
      this.panel.style.setProperty('--trade-menu-shift', '0px');
      const rect = this.panel.getBoundingClientRect();
      const shift = rect.left < 16 ? 16 - rect.left : Math.min(0, window.innerWidth - 16 - rect.right);
      this.panel.style.setProperty('--trade-menu-shift', `${shift}px`);
    }
    disconnectedCallback() {
      this.controller.abort();
      this.menuObserver?.disconnect();
    }
  });
}
